/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'unlock': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M11.947 1.6c2.602 0 4.702 2.168 4.702 4.834v3.515h2.037c1.113 0 2.007.923 2.007 2.051v8.349c0 1.128-.894 2.051-2.007 2.051H5.207c-1.113 0-2.007-.923-2.007-2.051V12c0-1.128.894-2.051 2.007-2.051H15.33V6.434c0-1.881-1.42-3.41-3.198-3.51l-.185-.005c-1.865 0-3.385 1.569-3.385 3.515a.66.66 0 01-1.319 0c0-2.666 2.101-4.834 4.704-4.834zm6.739 9.668H5.207c-.375 0-.688.323-.688.732v8.349c0 .408.313.732.688.732h13.479c.375 0 .688-.324.688-.732V12c0-.409-.313-.732-.688-.732z" _fill="#A5B1C1" fill-rule="evenodd"/>'
  }
})
